var _style, _circle, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSifdOrangeBmsSif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 164.5 87.5",
    style: {
      enableBackground: "new 0 0 164.5 87.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#XMLID_26_);stroke:url(#XMLID_27_);stroke-width:2;stroke-miterlimit:10;}\n\t.st1{fill:url(#XMLID_28_);stroke:url(#XMLID_29_);stroke-width:3;stroke-miterlimit:10;}\n\t.st2{fill:#00003E;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.3966,
    y1: 167.1192,
    x2: 163.1466,
    y2: 168.1192,
    gradientTransform: "matrix(-1.346900e-010 1 -1 -1.346900e-010 184.0919 -104.0533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2FBABD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#144F74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00003E"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.0606,
    y1: 167.4162,
    x2: 135.5589,
    y2: 167.5963,
    gradientTransform: "matrix(-1.346900e-010 1 -1 -1.346900e-010 184.0919 -104.0533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2FBABD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#144F74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00003E"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_330_",
    className: "st0",
    cx: 16.6,
    cy: 26.8,
    r: 3.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.4665,
    y1: 160.3825,
    x2: 198.3041,
    y2: 157.004,
    gradientTransform: "matrix(-1.346900e-010 1 -1 -1.346900e-010 184.0919 -104.0533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2FBABD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#144F74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00003E"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.5088,
    y1: 163.8093,
    x2: 170.6136,
    y2: 151.7235,
    gradientTransform: "matrix(-1.346900e-010 1 -1 -1.346900e-010 184.0919 -104.0533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2FBABD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#144F74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00003E"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_329_",
    className: "st1",
    d: "M36.4,62.1c2.8-2.8,4.2-6.7,4.2-11.7l0.2-9v-1.9c0-0.1,0-9.9-0.1-14.4 c-0.1-4.6-2.3-6.2-4.3-6.2c-2.2,0-3.1,0.6-5.8,7.8c-1.8,4.6-4.1,9.4-8.7,11.9c-3.9,2.2-9.1,2.8-10.3,3.9c-0.6,0.6-2.8,1.4-2.4,7.8 c0.3,4,1.1,9,3.8,11.7c2.7,2.8,6.7,4.2,11.8,4.2C29.7,66.3,33.7,64.9,36.4,62.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_54_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_99_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_104_",
    className: "st2",
    d: "M71.4,51.9c0,2-0.3,3.7-0.9,5.1c-0.6,1.4-1.4,2.6-2.4,3.6c-1,0.9-2.1,1.6-3.4,2.1 c-1.3,0.5-2.7,0.7-4.1,0.7h-9V22.2h9.3c1.3,0,2.5,0.2,3.6,0.6c1.1,0.4,2.1,1,3,1.9c0.9,0.8,1.5,1.9,2,3.2c0.5,1.3,0.7,2.8,0.7,4.5 c0,1.2-0.2,2.3-0.5,3.3c-0.3,1-0.7,1.9-1.3,2.7c-0.5,0.8-1.2,1.5-1.9,2c-0.8,0.6-1.6,0.9-2.5,1.1c2.2,0.3,3.9,1.4,5.3,3.3 C70.7,46.7,71.4,49,71.4,51.9z M67.2,33.1c0-1.3-0.2-2.4-0.5-3.4c-0.4-0.9-0.9-1.7-1.5-2.4c-0.6-0.6-1.4-1.1-2.2-1.4 c-0.8-0.3-1.8-0.5-2.7-0.5h-5.5v15.1h5.5c0.9,0,1.8-0.2,2.7-0.5c0.8-0.3,1.6-0.8,2.2-1.4c0.6-0.6,1.1-1.4,1.5-2.4 C67,35.4,67.2,34.3,67.2,33.1L67.2,33.1z M68.2,51.5c0-1.4-0.2-2.6-0.6-3.7c-0.4-1-1-1.9-1.7-2.6c-0.7-0.7-1.5-1.2-2.5-1.5 c-0.9-0.3-1.9-0.5-3-0.5h-5.8V60h5.5c1,0,2.1-0.2,3-0.5c1-0.3,1.8-0.8,2.5-1.5c0.7-0.7,1.3-1.6,1.7-2.6C68,54.3,68.2,53,68.2,51.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_102_",
    className: "st2",
    d: "M107.1,63.3V34.4c0-1.5-0.1-2.8-0.3-4.1c-0.2-1.2-0.5-2.3-1-3.1c-0.5-0.9-1.1-1.5-2-2 c-0.8-0.5-1.8-0.7-3.1-0.7c-1.2,0-2.3,0.2-3.1,0.7c-0.8,0.5-1.5,1.2-2,2c-0.5,0.9-0.8,1.9-1,3.1c-0.2,1.2-0.3,2.5-0.3,4v28.9h-3.1 V34.4c0-1.5-0.1-2.8-0.3-4.1c-0.2-1.2-0.5-2.3-1-3.1c-0.5-0.9-1.1-1.5-2-2c-0.8-0.5-1.8-0.7-3.1-0.7c-1.2,0-2.3,0.2-3.1,0.7 c-0.8,0.5-1.5,1.2-2,2c-0.5,0.9-0.8,1.9-1,3.1c-0.2,1.2-0.3,2.5-0.3,4v28.9h-3.1V33.2c0-3.9,0.8-6.9,2.4-8.9c1.6-2,4-3.1,7.1-3.1 c4,0,6.6,1.9,7.9,5.6c1.3-3.7,4-5.6,7.9-5.6c3.1,0,5.5,1,7.1,3.1c1.6,2,2.4,5,2.4,8.9v30.1H107.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_100_",
    className: "st2",
    d: "M138.5,52.5c0,2.1-0.3,3.9-1,5.4c-0.7,1.5-1.5,2.7-2.6,3.7c-1.1,1-2.3,1.6-3.7,2.1 c-1.4,0.4-2.8,0.7-4.3,0.7c-1.6,0-3.2-0.2-4.8-0.7c-1.6-0.5-3.1-1.3-4.4-2.5c-1.3-1.1-2.4-2.6-3.2-4.5c-0.8-1.9-1.2-4.2-1.2-6.9 h3.1c0,2.1,0.3,3.9,0.8,5.3c0.6,1.5,1.3,2.7,2.3,3.6c0.9,0.9,2.1,1.6,3.4,2c1.3,0.4,2.7,0.6,4.2,0.6c1,0,2.1-0.2,3.1-0.5 c1-0.3,1.9-0.8,2.7-1.5c0.8-0.7,1.4-1.6,1.9-2.6c0.5-1.1,0.7-2.3,0.7-3.8c0-1.7-0.3-3-0.9-4c-0.6-1-1.3-1.8-2.3-2.4 c-0.9-0.6-2-1.1-3.3-1.5c-1.2-0.4-2.5-0.8-3.7-1.2c-1.3-0.4-2.6-0.9-3.9-1.3c-1.3-0.5-2.4-1.1-3.5-1.8c-1-0.8-1.9-1.8-2.5-3 c-0.6-1.3-1-2.9-1-4.9c0-2.1,0.3-3.9,1-5.3c0.7-1.5,1.6-2.6,2.7-3.5c1.1-0.9,2.3-1.5,3.7-1.9c1.4-0.4,2.7-0.6,4.1-0.6 c1.6,0,3.1,0.2,4.5,0.7c1.4,0.5,2.6,1.2,3.7,2.2c1.1,1,1.9,2.3,2.5,3.9c0.6,1.6,1,3.6,1.1,5.9h-3c0-1.8-0.3-3.2-0.7-4.5 c-0.5-1.2-1.1-2.2-1.9-3c-0.8-0.8-1.7-1.3-2.8-1.7c-1.1-0.3-2.2-0.5-3.4-0.5c-1,0-1.9,0.1-2.9,0.4c-1,0.2-1.9,0.7-2.7,1.3 c-0.8,0.6-1.5,1.4-2,2.4c-0.5,1-0.8,2.2-0.8,3.8c0,1.6,0.3,2.8,0.9,3.8c0.6,1,1.4,1.7,2.4,2.3c1,0.6,2.1,1.1,3.4,1.5 c1.3,0.4,2.5,0.8,3.9,1.2c1.4,0.5,2.8,0.9,4,1.4c1.3,0.5,2.4,1.2,3.4,2c1,0.8,1.7,1.9,2.3,3.2C138.3,48.8,138.5,50.4,138.5,52.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_11_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_12_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_18_"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_19_"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_20_"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_22_"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_24_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSifdOrangeBmsSif);
export default __webpack_public_path__ + "static/media/SIFD_Orange_BMS_SIF.bb72b3bfbd996b3459d93046235c185f.svg";
export { ForwardRef as ReactComponent };